var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none-wapper"},[_c('el-empty',{attrs:{"image":_vm.$t('no_empty'),"description":_vm.$t('暂无数据')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }